import { render, staticRenderFns } from "./customReport.vue?vue&type=template&id=bf10d27a&scoped=true"
import script from "./customReport.vue?vue&type=script&lang=js"
export * from "./customReport.vue?vue&type=script&lang=js"
import style0 from "./customReport.vue?vue&type=style&index=0&id=bf10d27a&prod&scoped=true&lang=css"
import style1 from "./customReport.vue?vue&type=style&index=1&id=bf10d27a&prod&lang=scss&scoped=true"
import style2 from "./customReport.vue?vue&type=style&index=2&id=bf10d27a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf10d27a",
  null
  
)

export default component.exports